export default class HistoryInfoModel {
    id: number | null;
    inicio: string | null;
    final: string | null;
    videoUrl: string | null;
    createdAt: string | null;
    updatedAt: string | null;
    publishedAt: string | null;

    constructor(
        id: number | null,
        inicio: string | null,
        final: string | null,
        videoUrl: string | null,
        createdAt: string | null,
        updatedAt: string | null,
        publishedAt: string | null
    ) {
        this.id = id;
        this.inicio = inicio;
        this.final = final;
        this.videoUrl = videoUrl;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.publishedAt = publishedAt;
    }

    static fromApiResponse(data: any): HistoryInfoModel {
        const videoData = data.attributes.video?.data;
        const videoUrl = Array.isArray(videoData) && videoData.length > 0
            ? videoData[0]?.attributes?.url || null
            : null;

        return new HistoryInfoModel(
            data.id || null,
            data.attributes.Inicio || null,
            data.attributes.final || null,
            videoUrl,
            data.attributes.createdAt || null,
            data.attributes.updatedAt || null,
            data.attributes.publishedAt || null
        );
    }
}
